import { v4 as uuidv4 } from 'uuid';
import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface IEmpresappals {
  moneda:                    null | string;
  pais:                      null | string;
  empp_id:                   string;
  empp_nombre:               string;
  empp_nombre_comercial:     string;
  empp_nro_admin_tributaria: string;
  empp_direccion:            string;
  empp_depto:                null | string;
  empp_provincia:            null | string;
  empp_distrito:             null | string;
  empp_monedaid:             string;
  empp_imagen_url:           null | string;
  empp_paisid:               string;
  empp_activa:               boolean;
}

export interface IEmpresappalsResponse {
  statusCode:   number;
  statusMsg:    string;
  statusDetail: string;
  debugInfo:    null;
  httpCode:     null;
  attributes:   null;
  data:         IEmpresappals[];
  segment:      null;
}


export class EmpresappalsSystem {
  private readonly base = '/empresappals/get-empresappals';

  constructor(private requestHandler: XhrRequestHandler) {}

  async getEmpresappals(): Promise<IEmpresappalsResponse> {
    const header = { idtransaccion: uuidv4(), msgtransaccion: 'Consulta de Empresappals' };
    return this.requestHandler.getheader<IEmpresappalsResponse>(this.base, header);
  }

}
